import { storeCompeteProject } from "@/(front-desk)/utils/dataFetch"
import classNames from "classnames"

export default function Pagination(props) {

    const { type, current, total } = props

    if (total > 1) return (
        <div className="mt-10 flex items-center justify-center">
            <button
                className="mx-3 cursor-pointer"
                disabled={current === 1}
                onClick={() => {
                    storeCompeteProject(type, current - 1)
                }}
                aria-label="上一頁"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                    <path fill="#222222" d="M10.4969 6.0875H2.49063L5.67812 2.84375C5.84687 2.675 5.84687 2.4125 5.67812 2.24375C5.50937 2.075 5.24687 2.075 5.07812 2.24375L1.19687 6.18125C1.02812 6.35 1.02812 6.6125 1.19687 6.78125L5.07812 10.7188C5.15312 10.7937 5.26562 10.85 5.37813 10.85C5.49062 10.85 5.58437 10.8125 5.67812 10.7375C5.84687 10.5687 5.84687 10.3063 5.67812 10.1375L2.50937 6.93125H10.4969C10.7219 6.93125 10.9094 6.74375 10.9094 6.51875C10.9094 6.275 10.7219 6.0875 10.4969 6.0875Z" />
                </svg>
            </button>
            
            { Array(total).fill('item').map((item, index) => (
                <div
                    key={index}
                    className={classNames('mx-1 w-6 h-6 rounded flex items-center justify-center text-base cursor-pointer font-normal', {
                        'bg-main-600 text-white': (current === index + 1),
                    })}
                    onClick={() => {
                        storeCompeteProject(type, index + 1)
                    }}
                >{index + 1}</div>
            ))}

            <button
                className="mx-3 cursor-pointer"
                disabled={current === total}
                onClick={() => {
                    storeCompeteProject(type, current + 1)
                }}
                aria-label="下一頁"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                    <path fill="#222222" d="M1.50312 6.9125L9.50938 6.9125L6.32188 10.1562C6.15313 10.325 6.15313 10.5875 6.32188 10.7562C6.49063 10.925 6.75313 10.925 6.92188 10.7562L10.8031 6.81875C10.9719 6.65 10.9719 6.3875 10.8031 6.21875L6.92188 2.28125C6.84688 2.20625 6.73438 2.15 6.62188 2.15C6.50938 2.15 6.41563 2.1875 6.32188 2.2625C6.15313 2.43125 6.15313 2.69375 6.32188 2.8625L9.49063 6.06875L1.50312 6.06875C1.27813 6.06875 1.09063 6.25625 1.09063 6.48125C1.09063 6.725 1.27813 6.9125 1.50312 6.9125Z" />
                </svg>
            </button>
        </div>
    )
}